
import { Vue, Component, Prop } from "vue-property-decorator";

interface Benchmark {
  id: number;
  color: string;
  text: string;
}

@Component
export default class BenchmarkLabels extends Vue {
  @Prop({ required: true, type: Array }) benchmarks!: Benchmark[];

  mounted() {
    this.injectStyles();
  }

  handleRemove(id: number) {
    this.$emit("delete-benchmark", id);
  }

  private injectStyles() {
    if (document.getElementById("benchmark-labels-styles")) return;

    const css = `
    .benchmark-labels {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      align-items: center;
      background-color: #fbfbfb;
      padding-top: 5px;
      padding-left: 5px;
    }
    .benchmark-label {
      flex: 0 0 auto;
      background: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 3px;
      padding: 5px;
      margin-right: 5px;
      margin-bottom: 5px;
      white-space: nowrap;
    }
    .benchmark-color {
      display: inline-block;
      height: 10px;
      width: 10px;
      vertical-align: middle;
    }
    .benchmark-text {
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
      font-family: "Roboto", sans-serif;
      font-size: 12px;
      width: 225px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .benchmark-label button {
      margin-left: 8px;
      padding: 0;
      background: transparent;
      border: none;
      cursor: pointer;
      transition: transform 0.2s ease;
    }
    .benchmark-label button:hover {
      transform: scale(1.2);
    }
    .close-icon {
      width: 12px;
      height: 12px;
      display: block;
    }
    .close-bg {
      fill: #a3a3a3;
      transition: fill 0.2s ease;
    }
    .benchmark-label button:hover .close-bg {
      fill: #909090;
    }
  `;

    const style = document.createElement("style");
    style.id = "benchmark-labels-styles";
    style.textContent = css;
    document.head.append(style);
  }
}
